import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from './';

export type TemplateModernProps = TemplateProps;
export type TemplateModernXinglet = XingletInterface<TemplateModernProps>;

export const Modern = XingletWrapper<TemplateModernProps>(
  `@xing-com/crate-lebenslauf-templates-modern`
);
